import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrowserTabService {
  public browserTabStatus: BehaviorSubject<{active: boolean}> = new BehaviorSubject<{active: boolean}>({active: true});
  constructor() { }
  public setStatusActive() {
    this.browserTabStatus.next({active: true});
  }
  public setStatusInactive() {
    // temporarily disabled
    // this.browserTabStatus.next({active: false});
  }
  public get statusIsActive() {
    return this.browserTabStatus.value.active;
  }
}
